import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled from 'styled-components';
import { CancelIcon } from 'tombac-icons';
import { tombac } from '../../../shared/tombac';
import { Button } from '../../Button';
const Icon = styled(CancelIcon).withConfig({
  displayName: "ModalCloseButton__Icon"
})(["height:", ";width:", ";"], tombac.unit(24), tombac.unit(24));
export const ModalCloseButton = props => /*#__PURE__*/React.createElement(Button, _extends({
  $position: "absolute",
  $right: "2sp",
  $top: "2sp",
  variant: "flat",
  shape: "circle",
  size: "xs"
}, props), /*#__PURE__*/React.createElement(Icon, null));
//# sourceMappingURL=ModalCloseButton.js.map